import { render, staticRenderFns } from "./EchartsCustTrend.vue?vue&type=template&id=2c967ed0&"
import script from "./EchartsCustTrend.vue?vue&type=script&lang=js&"
export * from "./EchartsCustTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports